import { queryOptions, useQuery } from '@tanstack/react-query';
import { groupBy } from 'lodash-es';
import type { EmojiProps } from '../emoji/emoji';
import type { SymbolCategory } from '../symbol.type';

interface EmojiData {
  name: string;
  group: string;
  slug: string;
}

export const emojisQueryOptions = queryOptions({
  queryKey: ['/GetEmojis'],
  queryFn: async () => {
    const data = await import('./emoji-data').then((module) => module.default as Record<string, EmojiData>);

    return Object.entries(groupBy(Object.entries(data), ([, data]) => data.group)).map(
      ([key, value]): SymbolCategory<EmojiProps> => {
        const slug = key.replace(' & ', '_').toLowerCase();
        return {
          name: `emoji.${slug}`,
          slug: `emoji_category_${slug}`,
          symbols:
            value?.map(([emoji, { name }]) => ({
              slug: name,
              emoji: emoji,
            })) ?? [],
        };
      },
    );
  },
  placeholderData: [],
  staleTime: 30 * 24 * 60 * 60 * 1000,
  gcTime: 365 * 24 * 60 * 60 * 1000,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
});

export default function useEmojis() {
  const query = useQuery(emojisQueryOptions);

  return {
    emojis: query.data ?? [],
    ...query,
  };
}
